module.exports = __webpack_public_path__ + "static/media/3@720w.665ab521.jpg";